import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DownhillSkiingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"downhill_skiing"}/>
}
